export default __webpack_public_path__ + "static/media/expand.40983d06.svg";